import React from "react"

export const ChatNotConnect = () => {
  return (
    <>
      <div>
        <p>Não há conexão com este canal.</p>
      </div>
    </>
  )
}